// Imports => Moment
import moment from 'moment';
import 'moment/locale/de'
import 'moment/locale/nl'
import 'moment/locale/fr'

// Imports => Constants
import { KEYS } from '@opp/ui-kit';

// Imports => Utilities
import { AcGetState } from '@opp/ui-kit';

export const getLocale = () => {
  return AcGetState(KEYS.LOCALE) || 'en';
};

export const setLocale = (_locale) => {
  const locale = _locale || getLocale();

  moment.locale(locale);
};

export default {
  getLocale,
  setLocale,
};
